import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DashboardTotalsHttpService } from './dashboard-totals.http.service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { AbstractDashboardStore } from './abstract-dashboard.store';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { UserLocalStorageService } from '../../permission/services/user.local.storage.service';
import { User } from '../../auth/models/User';

@Injectable()
export class MissingAgencyDashboardStore extends AbstractDashboardStore {

  private missingAgencyTotalSubject = new BehaviorSubject<number>(0);

  constructor(
    private dashboardTotalsHttpService: DashboardTotalsHttpService,
    private flashMessagesService: FlashMessagesService,
    private authenticationStore: AuthenticationStore,
    private userLocalStorageService: UserLocalStorageService
  ) {
    super();
  }

  showCard(): Observable<boolean> {
    return this.authenticationStore.user.map((user: User) => {
      const dashboardFilterState = this.userLocalStorageService.getDashboardFilterState(user.email);
      return dashboardFilterState.missingAgency;
    });
  }

  get missingAgencyTotal(): Observable<number> {
    return this.missingAgencyTotalSubject.asObservable();
  }

  loadTotalsWithCardStateHandled(): Observable<any> {
    return this.dashboardTotalsHttpService.getMissingAgencyCount().catch(error => {
      this.flashMessagesService.error('MESSAGES.ERROR.GET_MISSING_AGENCY_TOTALS',
        `Error retrieving missing agency totals: ${error}`);
      return Observable.throw(error);
    }).map(missingAgencyTotal => {
      this.missingAgencyTotalSubject.next(missingAgencyTotal);
      return missingAgencyTotal;
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/missing-agency-dashboard.store.ts